import { Button, Form, message, Popconfirm, Table } from 'antd';
import { gql } from 'apollo-boost';
import React from 'react';
import { client } from 'src/services/api';
import { USER_SOURCE_TO_NAME } from 'src/types/teacher';
import styled from 'styled-components';

import { TeacherAllocation } from './AllocateTeacher';
import { EditableCell } from './EditableCell';

export const EditableContext = React.createContext(Form);

const editTeacherAllocationsMutation = gql`
  mutation editTeacherAllocations($skuId: ID!, $query: [EditTeaAllocationArg]) {
    editTeacherAllocations(skuId: $skuId, query: $query) {
      id
      turns
    }
  }
`;
const EditableRowStyle = styled.tr`
  :hover {
    .editable-cell-value-wrap {
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 4px 11px;
    }
  }
`;

// eslint-disable-next-line react/prop-types
const EditableRow = ({ form, index, ...props }) => {
  return (
    <EditableContext.Provider value={form}>
      <EditableRowStyle {...props} />
    </EditableContext.Provider>
  );
};
const EditableFormRow = Form.create()(EditableRow);
export interface TableData {
  id: number;
  teacherId: number;
  groupSize: number;
  groupPolicy: number;
  turns: number;
  round: number;
  skuId: number;
}
interface EditTeacherAllocations {
  editTeacherAllocations: TeacherAllocation[];
}
interface Props {
  teacherAllocations: TeacherAllocation[];
  skuId: string;
}
interface State {
  editingKey: string;
}
export class EditableTable extends React.Component<Props, State> {
  addTeacherAllocation: () => {};
  constructor(props: Props) {
    super(props);
    this.state = {
      editingKey: '',
    };
  }

  isEditing = record => record.id === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: '' });
  };

  save(form: any, record: any) {
    form.validateFields(async (error, row) => {
      if (error) {
        return;
      }
      const { skuId, id } = record;
      const { turns, userSource } = row;
      await client
        .mutate<EditTeacherAllocations>({
          mutation: editTeacherAllocationsMutation,
          variables: {
            skuId,
            query: {
              id,
              turns,
              userSource,
            },
          },
        })
        .then(() => {
          this.setState({ editingKey: '' });
          message.success('操作成功！');
        })
        .catch(error => {
          const [err] = error.graphQLErrors;
          message.error(err);
        });
    });
  }

  edit(key: string) {
    this.setState({ editingKey: key });
  }

  render() {
    const columnsOrigin = [
      {
        title: 'ID',
        dataIndex: 'id',
      },
      {
        title: '老师',
        dataIndex: 'teacher.name',
        key: 'teacherName',
      },
      {
        title: '剩余分配次数',
        dataIndex: 'turns',
        width: '30%',
        editable: true,
      },
      {
        title: '学生来源',
        dataIndex: 'userSource',
        width: '20%',
        editable: true,
        render: userSource => USER_SOURCE_TO_NAME[userSource],
      },
      {
        title: '操作',
        dateIndex: 'actions',
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {form => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={async () => {
                      this.save(form, record);
                    }}
                    style={{ marginRight: 8 }}
                  >
                    保存
                  </Button>
                )}
              </EditableContext.Consumer>
              <Popconfirm title="Sure to cancel?" onConfirm={() => this.cancel()}>
                <a>取消</a>
              </Popconfirm>
            </span>
          ) : (
            <Button size="small" type="primary" disabled={editingKey !== ''} onClick={() => this.edit(record.id)}>
              编辑
            </Button>
          );
        },
      },
    ];

    const { teacherAllocations } = this.props;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    const columns = columnsOrigin.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record) ? 1 : 0,
        }),
      };
    });
    return (
      <div>
        <Table
          components={components}
          rowClassName={() => 'editable-row'}
          rowKey={record => `${record.id}`}
          bordered
          pagination={false}
          dataSource={teacherAllocations}
          columns={columns}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/EditableTable.tsx